var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gis:flag-start-b",
    clipPath: "url(#clip0_2190_7096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00016 0C6.77737 0 6.56372 0.0884997 6.40619 0.24603C6.24866 0.403561 6.16016 0.617218 6.16016 0.84V20.04C6.16016 20.2628 6.24866 20.4764 6.40619 20.634C6.56372 20.7915 6.77737 20.88 7.00016 20.88C7.22294 20.88 7.4366 20.7915 7.59413 20.634C7.75166 20.4764 7.84016 20.2628 7.84016 20.04V11.28H18.1602C18.3829 11.28 18.5966 11.1915 18.7541 11.034C18.9117 10.8764 19.0002 10.6628 19.0002 10.44V0.84C19.0002 0.617218 18.9117 0.403561 18.7541 0.24603C18.5966 0.0884997 18.3829 0 18.1602 0H7.12016C7.09981 6.15957e-05 7.07948 0.000862124 7.0592 0.0024C7.03955 0.000907851 7.01986 0.000107356 7.00016 0Z",
    fill: "#133940"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.12101 18.4297C1.57845 18.7892 -0.199951 19.6489 -0.199951 20.9139C-0.199951 22.6179 2.77149 23.9996 7.00005 23.9996C11.2286 23.9996 14.2 22.6182 14.2 20.9139C14.2 19.6486 12.4216 18.7892 9.87933 18.4299L9.52701 19.0297C11.4434 19.2954 12.76 19.8543 12.76 20.5026C12.76 21.4114 10.1812 22.1482 7.00005 22.1482C3.81885 22.1482 1.24005 21.4114 1.24005 20.5026C1.23981 19.8565 2.54805 19.2982 4.47021 19.0314C4.35405 18.8307 4.23741 18.6306 4.12101 18.4297Z",
    fill: "#133940"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_7096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartFlag);
export default __webpack_public_path__ + "static/media/StartFlag.732c2538d19ed75277543c6cb2da3774.svg";
export { ForwardRef as ReactComponent };